var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLanguage = function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#4E4B66"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M12.368 14.586h.606l-.116-.595-.844-4.361h4.812c.371 0 .674.303.674.674v6.521a.675.675 0 0 1-.674.674h-5.65l-.582-2.913z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.645 11.423v.645h-.621v3.326h-.835v-1.397a.9.9 0 0 1-.266.042.8.8 0 0 1-.29-.06v.036c0 .668-.503 1.16-1.308 1.16-.775 0-1.177-.42-1.325-.64l.574-.526c.124.219.379.473.763.473.314 0 .497-.189.497-.45 0-.254-.183-.408-.562-.408h-.32v-.692h.208c.36 0 .509-.19.509-.456 0-.23-.16-.39-.415-.39a.56.56 0 0 0-.508.296l-.521-.491c.19-.273.562-.497 1.053-.497.692 0 1.154.396 1.154 1 0 .337-.154.627-.432.763v.024a.7.7 0 0 1 .201.07h.006q.018.017.036.024c.16.083.325.119.473.119.207 0 .36-.042.473-.101v-1.225h-.461v-.645z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M10.594 14.587h2.04L11.13 17.27z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.842 14.87H7.174A1.175 1.175 0 0 1 6 13.695V7.173C6 6.527 6.527 6 7.174 6h4.103c.187 0 .348.133.384.317l1.565 8.087a.39.39 0 0 1-.384.465"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E4B66",
    fillRule: "evenodd",
    d: "M9.905 11.358H8.46l-.274.824h-.877l1.49-4h.763l1.497 4h-.876zm-1.222-.668h1l-.502-1.497z",
    clipRule: "evenodd"
  })));
};
export default SvgLanguage;